// extracted by mini-css-extract-plugin
export default {"textLink":"textLink_textLink__ZK60O","mobileNav":"textLink_mobileNav__VcD5w","inline":"textLink_inline__ihgdu","footer":"textLink_footer__z-UGS"};